import React, { createContext, useState } from "react";

export const AccessDataContext = createContext();

const AccessContext = ({ children }) => {
  const [access, setAccess] = useState([]);

  return (
    <AccessDataContext.Provider value={{ access, setAccess }}>
      {children}
    </AccessDataContext.Provider>
  );
};

export default AccessContext;